import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import EditIcon from '../assets/edit-icon.svg';
import SaveIcon from '../assets/save-icon.svg';
import toast, { Toaster } from "react-hot-toast"



function GoalSettings() {
  const [name, setName] = useState("");
  const [birthdate, setBirthdate] = useState("");
  const [age, setAge] = useState(0);
  const [gender, setGender] = useState("");
  const [weight, setWeight] = useState(0);
  const [wUnit, setWUnit] = useState("");
  const [hUnit, setHUnit] = useState("CM");
  const [height, setHeight] = useState(0);
  const [edit, setEdit] = useState(true);
  const [edit2, setEdit2] = useState(true);
  const [hg, setHg] = useState(0);
  const { id } = useParams();

  const [globalEdit, setGlobalEdit] = useState(false);

  const [relationshipStatus, setRelationshipStatus] = useState("UNMARRIED");
  const [bloodGroup, setBloodGroup] = useState("O+");

  function handleGlobalEdit() {
    setEdit(false)
    setEdit2(false)
    setGlobalEdit(true)
  }
  function handleGlobalSave() {
    updatePersonalInfo();
    handleHealthGoal();
    setEdit(true)
    setEdit2(true)
    setGlobalEdit(false);

    toast.success('Changes Saved Successfully!')
  }

  const calAge = (birthdate) => {
    const today = new Date();
    const birthDate = new Date(birthdate);
    let calculatedAge = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();

    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      calculatedAge--;
    }
    setAge(calculatedAge);
  };

  const [healthProblems, setHealthProblems] = useState([]);
  const [cuisine, setCuisine] = useState(null);
  const [vnv, setVnv] = useState(null);
  const [foodAl, setFoodAl] = useState("");
  const [dislikeFood, setDislikeFood] = useState("");
  const [otherSpec, setOtherSpec] = useState("");

  const handleHp = (value) => {
    setHealthProblems((prev) =>
      prev.includes(value)
        ? prev.filter((hp) => hp !== value)
        : [...prev, value],
    );
  };

  const handleCuisine = (value) => {
    setCuisine(value);
  };

  const handleVnv = (value) => {
    setVnv(value);
  };

  useEffect(() => {
    // console.log(healthProblems);
    // console.log(cuisine);
    // console.log(vnv);
  }, [healthProblems, cuisine, vnv]);

  const [patient, setPatient] = useState([]);
  const [healthGoal, setHealthGoal] = useState();
  const [allStates, setAllStates] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const [stId, setStId] = useState(1);
  const [ctId, setCtId] = useState(null);
  const fetchData = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/patients/${id}/`,
      );
      const json = await response.json();
      console.log("API Response Person:", json);
      if (response.ok) {
        setPatient(json);
        setName(json.full_name);
        setGender(json.gender);
        setHeight(json.height);
        setWeight(json.weight);
        setWUnit(json.weight_unit);
        setHUnit(json.height_unit)
        setBloodGroup(json.blood_group);
        setRelationshipStatus(json.relationship)
        setStId(json.state);
        setCtId(json.city);
        setBirthdate(json.birthdate);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchData2 = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/states/`,
      );
      const json = await response.json();
      if (response.ok) {
        setAllStates(json);
        console.log("states", json);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchData3 = async () => {
    try {
      const formData = {
        id: parseInt(stId),
      };

      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/cities/`, {
        method: "POST",
        body: JSON.stringify(formData),
        headers: {
          "Content-Type": "application/json",
        },
      });
      const json = await response.json();
      if (response.ok) {
        setAllCities(json);
        // console.log("cities",json)
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchHg = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/health-goal/${id}/`,
      );
      const json = await response.json();
      if (response.ok) {
        setHealthGoal(json);
        setHg(healthGoal?.helth_goal?.id);
        const healthProblemIds = json?.helth_problem?.map(
          (problem) => problem.id,
        );
        setHealthProblems(healthProblemIds);
        setCuisine(json?.cuisine_option.id);
        setVnv(json?.veg_or_nonveg.id);
        setFoodAl(healthGoal?.food_allergies);
        setDislikeFood(healthGoal?.most_dislike_food);
        setOtherSpec(healthGoal?.other_specifi);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchData();
    fetchHg();
    fetchData2();
    fetchData3();
  }, []);

  useEffect(() => {
    fetchData3();
  }, [stId]);

  useEffect(() => {
    // console.log(patient);
    // console.log(healthGoal)
  }, [patient, healthGoal]);

  const updatePersonalInfo = async (e) => {
    if (e && e != undefined) e.preventDefault();
    // e.preventDefault();
    // console.log('update info');
    if (edit || globalEdit) {
      try {
        if (
          name === "" ||
          birthdate === "" ||
          gender === "" ||
          weight === "" ||
          height === ""
        ) {
          return console.log("Enter all data");
        }

        const formData = {
          full_name: name,
          birthdate: birthdate,
          gender: gender,
          weight: weight,
          weight_unit: wUnit,
          height: height,
          height_unit: hUnit,
          state: parseInt(stId),
          city: parseInt(ctId),
          blood_group: bloodGroup,
          relationship: relationshipStatus,
        };

        console.log("Form Data:", formData);
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/patients/${id}/`,
          {
            method: "PUT",
            body: JSON.stringify(formData),
            headers: {
              "Content-Type": "application/json",
            },
          },
        );

        const json = await response.json();
        console.log("API Response:", json);
        if (response.ok) {
          setEdit(true);
          setGlobalEdit(false)
          fetchData();
          // console.log("updated patient",json);
        }
        setEdit(true);
      } catch (error) {
        console.log(error);
        setEdit(true);
        setGlobalEdit(false)
      }
    }
  };

  function calculateMetrics(weight, height, waist, hip, wUnit, hUnit, gender) {
    // Convert weight and height to metric units if needed
    if (wUnit === "LBS") weight = weight * 0.453592; // Convert lbs to kg
    if (hUnit === "FT/IN") height = height * 0.3048; // Convert ft/in to meters
    if (hUnit === "CM") height = height / 100; // Convert cm to meters

    // Calculate BMI
    const bmi = weight / height ** 2;
    let bmiCategory;
    if (bmi < 18.5) bmiCategory = "Underweight";
    else if (bmi < 24.9) bmiCategory = "Normal weight";
    else if (bmi < 29.9) bmiCategory = "Overweight";
    else if (bmi < 34.9) bmiCategory = "Obese Class 1";
    else if (bmi < 39.9) bmiCategory = "Obese Class 2";
    else bmiCategory = "Obese Class 3";

    // Calculate WHR
    const whr = waist / hip;
    let whrCategory;
    if (whr < 0.8) whrCategory = "Low risk";
    else if (whr < 0.9) whrCategory = "Moderate risk";
    else whrCategory = "High risk";

    let idealWeight;
    if (gender == "FEMALE") {
      // female
      idealWeight = 45.5 + 0.91 * (height * 100 - 152.4);
    } else {
      // male
      idealWeight = 50 + 0.91 * (height * 100 - 152.4);
    }

    console.log(idealWeight, "ideal");

    return {
      bmi: bmi.toFixed(1) + ` (${bmiCategory})`,
      whr: whr.toFixed(2) + ` (${whrCategory})`,
      idealWeight: `${idealWeight.toFixed(1)} kg`,
    };
  }
  const [metrics, setMetrics] = useState({});
  useEffect(() => {
    const metricsCalculation = calculateMetrics(
      weight,
      height,
      30,
      0.8,
      wUnit,
      hUnit,
      gender,
    );
    setMetrics(metricsCalculation);
  }, [height, hUnit, gender]);

  const healthG = ["PCOD Management", "Weight Loss", "Muscle Gain"];

  const healthProb = [
    "Bloating",
    "Gas",
    "Body Pain",
    "Headache",
    "Skin Issues",
    "Hairfall Issue",
  ];

  const cuisineOpt = [
    "Gujarati",
    "Maharashtrian",
    "Andra",
    "Kerela",
    "Punjabi",
    "Assamese",
    "Rajasthani",
    "Bihari",
    "Karnataka",
    "Bengali",
  ];

  const vno = ["Vegetarian", "Non-vegetarian", "Eat eggs but not non veg"];

  const handleHealthGoal = async (e) => {
    if (e && e != undefined) e.preventDefault();
    try {
      const formData = {
        helth_goal: hg,
        other_specifi: otherSpec,
        helth_problem: healthProblems,
        cuisine_option: cuisine,
        veg_or_nonveg: vnv,
        food_allergies: foodAl,
        most_dislike_food: dislikeFood,
      };
      // console.log(formData)
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/health-goal/${id}/`,
        {
          method: "POST",
          body: JSON.stringify(formData),
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const json = await response.json();
      if (response.ok) {
        // console.log(json);
        setEdit2(true);
        setGlobalEdit(false)
        setHg(json.helth_goal?.id);
        fetchHg();
      }
    } catch (error) {
      // console.log(error);
    }
  };

  return (
    <div className="gsMain">
       <Toaster/>
      {/* Personal Info */}
      <div className="ccm goalSet">
        <div className="gs">
          <div className="ccmTop">
            <h1>Personal Info</h1>
          </div>
          <form
            className="slide"
            style={{ border: edit ? "" : "1px solid #F23D76" }}
            onSubmit={updatePersonalInfo}
          >
            <div className="slideCont">
              <p>
                Name:
                {edit ? (
                  <b>{name}</b>
                ) : (
                  <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                )}
              </p>
              <p>
                {/* {edit ? 'Age:' : 'Birthdate:'} */}
                Birthdate:
                {edit ? (
                  <b>{birthdate}</b>
                ) : (
                  <input
                    type="date"
                    value={birthdate}
                    onChange={(e) => {
                      setBirthdate(e.target.value);
                      calAge(e.target.value);
                    }}
                  />
                )}
              </p>
              <p>
                Gender:
                {edit ? (
                  <b>{gender}</b>
                ) : (
                  <select
                    value={gender}
                    onChange={(e) => setGender(e.target.value)}
                  >
                    <option value="MALE">Male (M)</option>
                    <option value="FEMALE">Female (F)</option>
                    <option value="OTHER">Other (O)</option>
                  </select>
                )}
              </p>
            </div>
            <div className="slideCont">
              <p>
                State:
                {edit ? (
                  <b>{allStates?.states?.find(s => s.id === stId)?.name}</b>
                ) : (
                  <select
                    value={allStates?.states?.find(s => s.id === stId)?.name}
                    onChange={(e) => {
                      const selectedOption = e.target.options[e.target.selectedIndex];
                      const stateId = selectedOption.getAttribute("data-id");
                      setStId(stateId);
                      console.log("Selected State ID:", stateId);
                    }}
                  >
                    {allStates?.states?.map((as, index) => (
                      <option value={as.name} key={index} data-id={as.id}>
                        {as.name}
                      </option>
                    ))}
                  </select>
                )}
              </p>
              <p>
                City:
                {edit ? (
                  <b>{allCities?.cities?.find(c => c.id === ctId)?.name}</b>
                ) : (
                  <select
                    value={allCities?.cities?.find(c => c.id === ctId)?.name}
                    onChange={(e) => {
                      setCtId(e.target.value);
                      const selectedOption = e.target.options[e.target.selectedIndex];
                      const cityId = selectedOption.getAttribute("data-id");
                      setCtId(cityId);
                      console.log("Selected City ID:", cityId);
                    }}
                  >
                    {allCities?.cities?.map((as, index) => (
                      <option value={as.name} key={index} data-id={as.id}>
                        {as.name}
                      </option>
                    ))}
                  </select>
                )}
              </p>

              {/* new dropdown field - blood group */}
              <p>
                Blood Group:
                {edit ? (
                  <b>{bloodGroup}</b>
                ) : (
                  <select
                    value={bloodGroup}
                    onChange={(e) => setBloodGroup(e.target.value)}
                  >
                    <option value="A+">A+</option>
                    <option value="A-">A-</option>
                    <option value="B+">B+</option>
                    <option value="B-">B-</option>
                    <option value="AB+">AB+</option>
                    <option value="AB-">AB-</option>
                    <option value="O+">O+</option>
                    <option value="O-">O-</option>
                  </select>
                )}
              </p>
            </div>

            <div className="slideCont">
              <p>
                Weight:
                {edit ? (
                  <b>{weight + wUnit}</b>
                ) : (
                  <div>
                    <label>
                      <input
                        type="radio"
                        name="weightUnit"
                        value="LBS"
                        onChange={(e) => setWUnit(e.target.value)}
                      />{" "}
                      Lbs
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="weightUnit"
                        value="KG"
                        defaultChecked
                        onChange={(e) => setWUnit(e.target.value)}
                      />{" "}
                      Kg
                    </label>
                    <input
                      type="number"
                      value={weight}
                      onChange={(e) => setWeight(e.target.value)}
                    />
                  </div>
                )}
              </p>
              <p>
                Height:
                {edit ? (
                  <b>{height + hUnit}</b>
                ) : (
                  <div>
                    <label>
                      <input
                        type="radio"
                        name="heightUnit"
                        value="FT/IN"
                        checked={hUnit === "FT/IN"} // Ensure this is checked based on state
                        onChange={(e) => setHUnit(e.target.value)} // Update hunit
                      />
                      Ft/In
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="heightUnit"
                        value="CM"
                        checked={hUnit === "CM"} // Ensure this is checked based on state
                        onChange={(e) => setHUnit(e.target.value)} // Update hunit
                      />
                      Cm
                    </label>
                    <input
                      type="number"
                      value={height}
                      onChange={(e) => setHeight(e.target.value)}
                    />
                    <p>Height Unit: {hUnit}</p>{" "}
                    {/* Display the selected height unit */}
                  </div>
                )}
              </p>
            </div>
            <div className="slideCont">
              <p>
                Relationship Status:
                {edit ? (
                  <b>{relationshipStatus || "Not Specified"}</b>
                ) : (
                  <div>
                    <label>
                      <input
                        type="radio"
                        name="relationshipStatus"
                        value="Married"
                        onChange={(e) => setRelationshipStatus("MARRIED")}
                      />{" "}
                      Married
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="relationshipStatus"
                        value="Unmarried"
                        onChange={(e) => setRelationshipStatus("UNMARRIED")}
                      />{" "}
                      Unmarried
                    </label>
                  </div>
                )}
              </p>
            </div>

            <div className="slideCont">
              <p>
                BMI: <b className="bmi">{metrics.bmi}</b>
              </p>

              <p>
                Ideal Weight: <b className="iwr">{metrics.idealWeight}</b>
              </p>
            </div>
          </form>
        </div>
      </div>

      {/* Health Goal */}
      <div className="ccm goalSet">
        <form className="gs" onSubmit={(e) => handleHealthGoal(e)}>
          <div className="ccmTop">
            <h1>Health Goal</h1>
          </div>
          <div
            className="slide"
            style={{ border: edit2 ? "" : "1px solid #F23D76" }}
          >
            <div className="slideCont">
              <div className="sc">
                <p>What is your Current Health Goal?</p>
                <div className="scInfo">
                  <p>
                  {edit2 ? (
          <b>{healthGoal?.helth_goal?.name}</b>
        ) : (
          <select
            value={hg}
            onChange={(e) => setHg(Number(e.target.value))}
          >
                      {" "}
                      <option value="">Select Health Goal</option>
                      <option value={3}>Muscle Gain</option>
                      <option value={4}>Weight Loss</option>
                      <option value={5}>PCOD Management</option>
                      <option value={6}>Diabetes Management</option>
                      <option value={7}>Liver Management</option>
                      <option value={8}>Heart Management</option>
                      <option value={9}>Kidney Management</option>
                      <option value={10}>Women's health</option>
                    </select>
        )}
                  </p>
                  <div className="scdIn">
                    <p>If other/additions specify: </p>
                    {edit2 ? (
                      <input
                        type="text"
                        value={healthGoal?.other_specifi}
                        readOnly={edit2}
                        style={{ border: edit2 ? "" : "1px solid #707070" }}
                      />
                    ) : (
                      <input
                        type="text"
                        value={healthGoal?.other_specifi}
                        onChange={(e) => setOtherSpec(e.target.value)}
                        readOnly={edit2}
                        style={{ border: edit2 ? "" : "1px solid #707070" }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="slideCont">
              <div className="sc">
                <p>
                  Are you facing any health problems like: (select multiple)
                </p>
                <div className="scInfo">
                  {edit2 ? (
                    <div className="hps">
                      {healthProb.map((problem, index) => (
                        <label key={index}>
                          <input
                            type="checkbox"
                            value={index + 4} // Use index+1 to match with healthProblems array values
                            readOnly="true"
                            disabled
                            checked={healthProblems.includes(index + 4)} // Check if the problem exists in the healthProblems array
                            onChange={(e) => handleHp(Number(e.target.value))} // Convert value to number and handle state change
                          />{" "}
                          {problem}
                        </label>
                      ))}
                    </div>
                  ) : (
                    <div>
                      {healthProb.map((problem, index) => (
                        <label key={index}>
                          <input
                            type="checkbox"
                            value={index + 4} // Use index+1 to match with healthProblems array values
                            checked={healthProblems.includes(index + 4)} // Check if the problem exists in the healthProblems array
                            onChange={(e) => handleHp(Number(e.target.value))} // Convert value to number and handle state change
                          />{" "}
                          {problem}
                        </label>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="slideCont">
              <div className="sc">
                <p>Cuisine option:</p>
                <div className="scInfo">
                  {edit2 ? (
                    <div>
                      <label>
                        <input
                          type="radio"
                          value={27}
                          readOnly
                          disabled
                          checked={cuisine === 27 ? true : false}
                          onChange={(e) =>
                            handleCuisine(Number(e.target.value))
                          }
                        />{" "}
                        Gujarati
                      </label>
                      <label>
                        <input
                          type="radio"
                          value={28}
                          readOnly
                          disabled
                          checked={cuisine === 28 ? true : false}
                          onChange={(e) =>
                            handleCuisine(Number(e.target.value))
                          }
                        />{" "}
                        Maharashtrian
                      </label>
                      <label>
                        <input
                          type="radio"
                          value={29}
                          readOnly
                          disabled
                          checked={cuisine === 29 ? true : false}
                          onChange={(e) =>
                            handleCuisine(Number(e.target.value))
                          }
                        />{" "}
                        Andhra
                      </label>
                      <label>
                        <input
                          type="radio"
                          value={30}
                          readOnly
                          disabled
                          checked={cuisine === 30 ? true : false}
                          onChange={(e) =>
                            handleCuisine(Number(e.target.value))
                          }
                        />{" "}
                        Kerela
                      </label>
                      <label>
                        <input
                          type="radio"
                          value={31}
                          readOnly
                          disabled
                          checked={cuisine === 31 ? true : false}
                          onChange={(e) =>
                            handleCuisine(Number(e.target.value))
                          }
                        />{" "}
                        Punjabi
                      </label>
                      <label>
                        <input
                          type="radio"
                          value={32}
                          readOnly
                          disabled
                          checked={cuisine === 32 ? true : false}
                          onChange={(e) =>
                            handleCuisine(Number(e.target.value))
                          }
                        />{" "}
                        Assamese
                      </label>
                      <label>
                        <input
                          type="radio"
                          value={33}
                          readOnly
                          disabled
                          checked={cuisine === 33 ? true : false}
                          onChange={(e) =>
                            handleCuisine(Number(e.target.value))
                          }
                        />{" "}
                        Rajasthani
                      </label>
                      <label>
                        <input
                          type="radio"
                          value={34}
                          readOnly
                          disabled
                          checked={cuisine === 34 ? true : false}
                          onChange={(e) =>
                            handleCuisine(Number(e.target.value))
                          }
                        />{" "}
                        Bihari
                      </label>
                      <label>
                        <input
                          type="radio"
                          value={35}
                          readOnly
                          disabled
                          checked={cuisine === 35 ? true : false}
                          onChange={(e) =>
                            handleCuisine(Number(e.target.value))
                          }
                        />{" "}
                        Karnataka
                      </label>
                      <label>
                        <input
                          type="radio"
                          value={36}
                          readOnly
                          disabled
                          checked={cuisine === 36 ? true : false}
                          onChange={(e) =>
                            handleCuisine(Number(e.target.value))
                          }
                        />{" "}
                        Bengali
                      </label>
                    </div>
                  ) : (
                    <div>
                      <label>
                        <input
                          type="radio"
                          value={27}
                          checked={cuisine === 27 ? true : false}
                          onChange={(e) =>
                            handleCuisine(Number(e.target.value))
                          }
                        />{" "}
                        Gujarati
                      </label>
                      <label>
                        <input
                          type="radio"
                          value={28}
                          checked={cuisine === 28 ? true : false}
                          onChange={(e) =>
                            handleCuisine(Number(e.target.value))
                          }
                        />{" "}
                        Maharashtrian
                      </label>
                      <label>
                        <input
                          type="radio"
                          value={29}
                          checked={cuisine === 29 ? true : false}
                          onChange={(e) =>
                            handleCuisine(Number(e.target.value))
                          }
                        />{" "}
                        Andra
                      </label>
                      <label>
                        <input
                          type="radio"
                          value={30}
                          checked={cuisine === 30 ? true : false}
                          onChange={(e) =>
                            handleCuisine(Number(e.target.value))
                          }
                        />{" "}
                        Kerela
                      </label>
                      <label>
                        <input
                          type="radio"
                          value={31}
                          checked={cuisine === 31 ? true : false}
                          onChange={(e) =>
                            handleCuisine(Number(e.target.value))
                          }
                        />{" "}
                        Punjabi
                      </label>
                      <label>
                        <input
                          type="radio"
                          value={32}
                          checked={cuisine === 32 ? true : false}
                          onChange={(e) =>
                            handleCuisine(Number(e.target.value))
                          }
                        />{" "}
                        Assamese
                      </label>
                      <label>
                        <input
                          type="radio"
                          value={33}
                          checked={cuisine === 33 ? true : false}
                          onChange={(e) =>
                            handleCuisine(Number(e.target.value))
                          }
                        />{" "}
                        Rajasthani
                      </label>
                      <label>
                        <input
                          type="radio"
                          value={34}
                          checked={cuisine === 34 ? true : false}
                          onChange={(e) =>
                            handleCuisine(Number(e.target.value))
                          }
                        />{" "}
                        Bihari
                      </label>
                      <label>
                        <input
                          type="radio"
                          value={35}
                          checked={cuisine === 35 ? true : false}
                          onChange={(e) =>
                            handleCuisine(Number(e.target.value))
                          }
                        />{" "}
                        Karnataka
                      </label>
                      <label>
                        <input
                          type="radio"
                          value={36}
                          checked={cuisine === 36 ? true : false}
                          onChange={(e) =>
                            handleCuisine(Number(e.target.value))
                          }
                        />{" "}
                        Bengali
                      </label>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="slideCont">
              <div className="sc">
                <p>Are you a vegetarian or non-vegetarian?</p>
                <div className="scInfo">
                  {edit2 ? (
                    <div>
                      <label>
                        <input
                          type="radio"
                          disabled
                          value={1}
                          checked={vnv === 1 ? true : false}
                          onChange={(e) => handleVnv(Number(e.target.value))}
                        />{" "}
                        Vegetarian
                      </label>
                      <label>
                        <input
                          type="radio"
                          disabled
                          value={2}
                          checked={vnv === 2 ? true : false}
                          onChange={(e) => handleVnv(Number(e.target.value))}
                        />{" "}
                        Non-vegetarian
                      </label>
                      <label>
                        <input
                          type="radio"
                          disabled
                          value={3}
                          checked={vnv === 3 ? true : false}
                          onChange={(e) => handleVnv(Number(e.target.value))}
                        />{" "}
                        Eat eggs but not non veg
                      </label>
                    </div>
                  ) : (
                    <div>
                      <label>
                        <input
                          type="radio"
                          value={1}
                          checked={vnv === 1 ? true : false}
                          onChange={(e) => handleVnv(Number(e.target.value))}
                        />{" "}
                        Vegetarian
                      </label>
                      <label>
                        <input
                          type="radio"
                          value={2}
                          checked={vnv === 2 ? true : false}
                          onChange={(e) => handleVnv(Number(e.target.value))}
                        />{" "}
                        Non-vegetarian
                      </label>
                      <label>
                        <input
                          type="radio"
                          value={3}
                          checked={vnv === 3 ? true : false}
                          onChange={(e) => handleVnv(Number(e.target.value))}
                        />{" "}
                        Eat eggs but not non veg
                      </label>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="slideCont">
              <div className="alg">
                <p>Are there any food allergies?</p>
                {edit2 ? (
                  <textarea
                    readOnly={edit2}
                    value={healthGoal?.food_allergies}
                    style={{ border: edit2 ? "" : "1px solid #707070" }}
                  ></textarea>
                ) : (
                  <textarea
                    readOnly={edit2}
                    value={foodAl}
                    onChange={(e) => setFoodAl(e.target.value)}
                    style={{ border: edit2 ? "none" : "1px solid #707070" }}
                  ></textarea>
                )}
              </div>
            </div>
            <div className="slideCont">
              <div className="alg">
                <p>Food items that you dislike the most?</p>
                {edit2 ? (
                  <textarea
                    readOnly={edit2}
                    value={healthGoal?.most_dislike_food}
                    style={{ border: edit2 ? "" : "1px solid #707070" }}
                  ></textarea>
                ) : (
                  <textarea
                    readOnly={edit2}
                    value={dislikeFood}
                    onChange={(e) => setDislikeFood(e.target.value)}
                    style={{ border: edit2 ? "none" : "1px solid #707070" }}
                  ></textarea>
                )}
              </div>
            </div>
          </div>
        </form>
      </div>
      <button
        className='edit-all-btn'
        onClick={() => {
          if (globalEdit) {
            handleGlobalSave();
          } else {
            handleGlobalEdit();
          }
        }}
        style={{
          backgroundColor: globalEdit ? '#f23d76' : '#393939',
          color: 'white',
          zIndex: 1000,
          padding: '1px 20px',
          border: 'none',
          borderRadius: '28px',
          width: '167px',
          height: '45px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '15px',
          /* font-weight: bold; */
          transition: 'background-color 0.3s',
          textAlign: 'center',
          filter: globalEdit ? 'drop-shadow(0px 0px 6px #f23d76)' : 'drop-shadow(0px 0px 6px #393939)'
        }}
      >
        {globalEdit ? 'Save changes' : 'Edit this section'}
      </button>
    </div>
  );
}

export default GoalSettings;
